import { Flex } from '@chakra-ui/react';
import { AlertOutlineIcon } from 'Asset/icon/index';
import { TextBold } from 'UiKit/typography';
import { Condition } from 'Component/others';

import { useLoginState } from 'View/login/state';

import styles from './styles.module.css';

const Error = () => {
  const { state } = useLoginState();

  return (
    <Condition statement={state?.errorMessage}>
      <Flex className={styles['error__container']}>
        <AlertOutlineIcon color="var(--color-error50)" />
        <TextBold className={styles['error-title__text']}>{state?.errorMessage}</TextBold>
      </Flex>
    </Condition>
  );
};

export default Error;
